import React from 'react'
import Menu from '../component/Menu';
import { Helmet } from 'react-helmet';
import Getintouch2 from '../component/Getintouch2'
import FooterNew from '../component/FooterNew';
import ServicesHeader from '../component/ServicesHeader';
import Whoweserve from '../component/Whoweserve';
import ServiceDesc from '../component/ServiceDesc';
import AIInServices from '../component/AIInService';
import ServiceSection from '../component/ServiceSection';


import heroimage from '../images/cfoherobg.webp';

import service1heroImage from '../images/Financial Planning.webp';
import ser1cs from '../images/case-study-client27.webp';
import service2heroImage from '../images/Investment & Fund Operations.webp';
import ser2cs from '../images/case-study-client23.webp';
import service3heroImage from '../images/AccountingData.webp';
import ser3cs from '../images/case-study-client43.webp';
import service4heroImage from '../images/GovernanceData.webp';
import ser4cs from '../images/case-study-client27.webp';
import FaqServices from '../component/FaqServices';
import ServiceCS from '../component/ServiceCS';


import cofcs1 from '../images/case-study-client47.webp'; 
import cofcs2 from '../images/case-study-client43.webp'; 
import cofcs3 from '../images/case-study-client38.webp'; 

const herocontent = {
  "l1": "Insight driven",
  "l2": "CFO services",
  "l3": "Insightful finance. Strategic execution. Sustainable value.",
  "img": heroimage
};


const serviceDes = {
    description:
      "We partner with organisations to design and scale insight-led finance functions, combining deep expertise, structured frameworks, and advanced analytics to drive clarity, governance, and informed strategic decisions",

    stats: [
      {
        title: "110+",
        text: "Finance departments supported",
      },
      {
        title: "500+",
        text: "FP&A delivered",
      },
      {
        title: "95%+",
        text: "On-time reporting enabled",
      },
    ],

    cta: {
      text: "VIEW OUR CASE STUDIES",
      href: "/case-studies",
    },
  };

const aiCFOData = {
    eyebrow: "ARTIFICIAL INTELLIGENCE",

    title: "AI in CFO Services",

    description:
      "The finance function is where AI's impact is most immediate - and most measurable. For CFOs and finance leaders, AI-enabled finance operations are fast becoming table stakes: faster closes, sharper forecasts, and finance teams that spend their time advising the business, not assembling it. We help you build an AI-augmented finance function without the cost of building it in-house.",

    cards: [
      {
        icon: "fpa",
        title: "Intelligent FP&A",
        description:
          "We embed AI into budgeting, forecasting, and variance analysis -   using driver-based, predictive models that update continuously, so your forecasts reflect the business as it is today, not as it was last quarter.",
      },
      {
        icon: "reporting",
        title: "Automated reporting & MIS",
        description:
          "We use AI to automate recurring management reporting, board packs, and investor updates - compressing preparation cycles from days to hours while improving accuracy and consistency.",
      },
      {
        icon: "risk",
        title: "Proactive cash & risk visibility",
        description:
          "We build AI-enabled cash-flow forecasting and early-warning systems that flag liquidity pressure, covenant risks, and expense anomalies before they become problems - giving you time to act, not react.",
      },
    ],

    bottom: [
      {
        title: "REAL OUTCOMES",
        description:
          "We've helped finance teams modernize with AI - from automating monthly MIS for a multi-entity group to building rolling cash-flow forecasts for a growth-stage company. The outcome: a faster, leaner finance function focused on decisions, not data entry.",
        linkText: "Read the case study",
        href: "/knowledge#casestudies",
      },
      {
        title: "HOW WE HELP",
        description:
          "Our CFO Services team operates as your offshore finance office - combining experienced finance professionals with generative and agentic AI across FP&A, reporting, and controllership - delivering CFO-grade insight at a fraction of the in-house cost.",
        linkText: "Talk to our team",
        href: "/contact#contactform",
      },
    ],
  };

const aiCFODataicons = {
  fpa: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.66602 6.66634C4.66602 5.78229 5.01721 4.93444 5.64233 4.30932C6.26745 3.6842 7.11529 3.33301 7.99935 3.33301H21.3327C22.2167 3.33301 23.0646 3.6842 23.6897 4.30932C24.3148 4.93444 24.666 5.78229 24.666 6.66634V13.9997C24.666 14.1765 24.5958 14.3461 24.4708 14.4711C24.3457 14.5961 24.1762 14.6663 23.9993 14.6663C23.8225 14.6663 23.653 14.5961 23.5279 14.4711C23.4029 14.3461 23.3327 14.1765 23.3327 13.9997V6.66634C23.3327 6.13591 23.122 5.6272 22.7469 5.25213C22.3718 4.87705 21.8631 4.66634 21.3327 4.66634H7.99935C7.46892 4.66634 6.96021 4.87705 6.58514 5.25213C6.21006 5.6272 5.99935 6.13591 5.99935 6.66634V25.333C5.99935 25.8634 6.21006 26.3721 6.58514 26.7472C6.96021 27.1223 7.46892 27.333 7.99935 27.333H17.3327C17.5095 27.333 17.6791 27.4032 17.8041 27.5283C17.9291 27.6533 17.9993 27.8229 17.9993 27.9997C17.9993 28.1765 17.9291 28.3461 17.8041 28.4711C17.6791 28.5961 17.5095 28.6663 17.3327 28.6663H7.99935C7.11529 28.6663 6.26745 28.3152 5.64233 27.69C5.01721 27.0649 4.66602 26.2171 4.66602 25.333V6.66634Z" fill="white"/>
<path d="M24.001 18.0003C24.1778 18.0003 24.3474 18.0706 24.4724 18.1956C24.5974 18.3206 24.6676 18.4902 24.6676 18.667V19.5563H24.893C26.1596 19.5563 27.3343 20.4683 27.3343 21.7777C27.3343 21.9545 27.2641 22.124 27.139 22.2491C27.014 22.3741 26.8445 22.4443 26.6676 22.4443C26.4908 22.4443 26.3213 22.3741 26.1962 22.2491C26.0712 22.124 26.001 21.9545 26.001 21.7777C26.001 21.3643 25.593 20.8897 24.893 20.8897H22.885C22.3116 20.8897 22.001 21.2803 22.001 21.5777C22.001 21.8617 22.0703 21.9577 22.1116 22.0017C22.173 22.067 22.297 22.143 22.5783 22.227L25.801 23.1617C26.1516 23.2657 26.5543 23.4257 26.8623 23.7537C27.1916 24.1043 27.3343 24.559 27.3343 25.0897C27.3343 26.287 26.253 27.111 25.117 27.111H24.6676V28.0003C24.6676 28.1771 24.5974 28.3467 24.4724 28.4717C24.3474 28.5968 24.1778 28.667 24.001 28.667C23.8242 28.667 23.6546 28.5968 23.5296 28.4717C23.4045 28.3467 23.3343 28.1771 23.3343 28.0003V27.111H23.109C21.8423 27.111 20.6676 26.199 20.6676 24.8897C20.6676 24.7128 20.7379 24.5433 20.8629 24.4183C20.9879 24.2932 21.1575 24.223 21.3343 24.223C21.5111 24.223 21.6807 24.2932 21.8057 24.4183C21.9307 24.5433 22.001 24.7128 22.001 24.8897C22.001 25.303 22.409 25.7777 23.109 25.7777H25.117C25.6903 25.7777 26.001 25.387 26.001 25.0897C26.001 24.8057 25.9316 24.7097 25.8903 24.6657C25.829 24.6003 25.705 24.5243 25.4236 24.4403L22.201 23.5057C21.8503 23.4017 21.4476 23.2417 21.1396 22.9137C20.8103 22.563 20.6676 22.1083 20.6676 21.5777C20.6676 20.3803 21.749 19.5563 22.885 19.5563H23.3343V18.667C23.3343 18.4902 23.4045 18.3206 23.5296 18.1956C23.6546 18.0706 23.8242 18.0003 24.001 18.0003ZM8.66764 14.667C8.66764 14.4902 8.73788 14.3206 8.8629 14.1956C8.98793 14.0706 9.1575 14.0003 9.33431 14.0003H10.001C10.1778 14.0003 10.3474 14.0706 10.4724 14.1956C10.5974 14.3206 10.6676 14.4902 10.6676 14.667C10.6676 14.8438 10.5974 15.0134 10.4724 15.1384C10.3474 15.2634 10.1778 15.3337 10.001 15.3337H9.33431C9.1575 15.3337 8.98793 15.2634 8.8629 15.1384C8.73788 15.0134 8.66764 14.8438 8.66764 14.667ZM12.6676 14.667C12.6676 14.4902 12.7379 14.3206 12.8629 14.1956C12.9879 14.0706 13.1575 14.0003 13.3343 14.0003H20.001C20.1778 14.0003 20.3474 14.0706 20.4724 14.1956C20.5974 14.3206 20.6676 14.4902 20.6676 14.667C20.6676 14.8438 20.5974 15.0134 20.4724 15.1384C20.3474 15.2634 20.1778 15.3337 20.001 15.3337H13.3343C13.1575 15.3337 12.9879 15.2634 12.8629 15.1384C12.7379 15.0134 12.6676 14.8438 12.6676 14.667ZM8.66764 18.667C8.66764 18.4902 8.73788 18.3206 8.8629 18.1956C8.98793 18.0706 9.1575 18.0003 9.33431 18.0003H10.001C10.1778 18.0003 10.3474 18.0706 10.4724 18.1956C10.5974 18.3206 10.6676 18.4902 10.6676 18.667C10.6676 18.8438 10.5974 19.0134 10.4724 19.1384C10.3474 19.2634 10.1778 19.3337 10.001 19.3337H9.33431C9.1575 19.3337 8.98793 19.2634 8.8629 19.1384C8.73788 19.0134 8.66764 18.8438 8.66764 18.667ZM12.6676 18.667C12.6676 18.4902 12.7379 18.3206 12.8629 18.1956C12.9879 18.0706 13.1575 18.0003 13.3343 18.0003H18.001C18.1778 18.0003 18.3474 18.0706 18.4724 18.1956C18.5974 18.3206 18.6676 18.4902 18.6676 18.667C18.6676 18.8438 18.5974 19.0134 18.4724 19.1384C18.3474 19.2634 18.1778 19.3337 18.001 19.3337H13.3343C13.1575 19.3337 12.9879 19.2634 12.8629 19.1384C12.7379 19.0134 12.6676 18.8438 12.6676 18.667ZM8.66764 22.667C8.66764 22.4902 8.73788 22.3206 8.8629 22.1956C8.98793 22.0706 9.1575 22.0003 9.33431 22.0003H10.001C10.1778 22.0003 10.3474 22.0706 10.4724 22.1956C10.5974 22.3206 10.6676 22.4902 10.6676 22.667C10.6676 22.8438 10.5974 23.0134 10.4724 23.1384C10.3474 23.2634 10.1778 23.3337 10.001 23.3337H9.33431C9.1575 23.3337 8.98793 23.2634 8.8629 23.1384C8.73788 23.0134 8.66764 22.8438 8.66764 22.667ZM12.6676 22.667C12.6676 22.4902 12.7379 22.3206 12.8629 22.1956C12.9879 22.0706 13.1575 22.0003 13.3343 22.0003H16.001C16.1778 22.0003 16.3474 22.0706 16.4724 22.1956C16.5974 22.3206 16.6676 22.4902 16.6676 22.667C16.6676 22.8438 16.5974 23.0134 16.4724 23.1384C16.3474 23.2634 16.1778 23.3337 16.001 23.3337H13.3343C13.1575 23.3337 12.9879 23.2634 12.8629 23.1384C12.7379 23.0134 12.6676 22.8438 12.6676 22.667ZM9.04631 6.00032H20.289C20.457 6.00032 20.621 6.00032 20.7596 6.01099C20.9116 6.02432 21.093 6.05366 21.273 6.14566C21.5238 6.27348 21.7278 6.47745 21.8556 6.72832C21.949 6.90966 21.977 7.08832 21.989 7.24166C22.001 7.38032 22.001 7.54432 22.001 7.71232V9.62166C22.001 9.78966 22.001 9.95366 21.989 10.0923C21.9794 10.2706 21.934 10.4452 21.8556 10.6057C21.7278 10.8565 21.5238 11.0605 21.273 11.1883C21.1125 11.2667 20.938 11.312 20.7596 11.3217C20.6029 11.3312 20.446 11.3352 20.289 11.3337H9.04631C8.87831 11.3337 8.71431 11.3337 8.57564 11.323C8.39723 11.313 8.22267 11.2672 8.06231 11.1883C7.81143 11.0605 7.60747 10.8565 7.47964 10.6057C7.40127 10.4452 7.35593 10.2706 7.34631 10.0923C7.33677 9.93562 7.33276 9.77864 7.33431 9.62166V7.71232C7.33431 7.54432 7.33431 7.38032 7.34497 7.24166C7.35831 7.08966 7.38764 6.90832 7.47964 6.72832C7.60747 6.47745 7.81143 6.27348 8.06231 6.14566C8.22276 6.06728 8.39733 6.02194 8.57564 6.01232C8.73234 6.00278 8.88933 5.99878 9.04631 6.00032ZM8.67564 7.34166V7.34966C8.66764 7.42832 8.66764 7.53632 8.66764 7.73366V9.60032C8.6655 9.73104 8.66817 9.8618 8.67564 9.99232H8.68364C8.76231 10.0003 8.87031 10.0003 9.06764 10.0003H20.2676C20.465 10.0003 20.5743 10.0003 20.6516 9.99366H20.6596V9.98432C20.6669 9.85646 20.6696 9.72838 20.6676 9.60032V7.73366C20.6698 7.60294 20.6671 7.47218 20.6596 7.34166H20.6516C20.5238 7.33438 20.3957 7.33171 20.2676 7.33366H9.06764C8.93692 7.33152 8.80616 7.33419 8.67564 7.34166Z" fill="white"/>
</svg>

  ),

  reporting: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.33398 23.9997V21.333M16.0007 23.9997V19.9997M22.6673 23.9997V17.333M3.33398 15.9997C3.33398 10.029 3.33398 7.04234 5.18865 5.18767C7.04332 3.33301 10.0287 3.33301 16.0007 3.33301C21.9713 3.33301 24.958 3.33301 26.8127 5.18767C28.6673 7.04234 28.6673 10.0277 28.6673 15.9997C28.6673 21.9703 28.6673 24.957 26.8127 26.8117C24.958 28.6663 21.9727 28.6663 16.0007 28.6663C10.03 28.6663 7.04332 28.6663 5.18865 26.8117C3.33398 24.957 3.33398 21.9717 3.33398 15.9997Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.99023 15.314C10.8636 15.41 17.3796 14.9766 21.0862 9.09398M18.6569 8.38331L21.1582 7.98065C21.4622 7.94198 21.9102 8.18331 22.0209 8.46998L22.6809 10.654" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  ),

  risk: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3326 8.6683L4.48929 24.0016H22.176L20.0406 20.2983C20.632 20.6059 21.2709 20.8117 21.9306 20.907L23.908 24.335C23.9665 24.4364 23.9973 24.5514 23.9973 24.6685C23.9972 24.7855 23.9664 24.9005 23.9078 25.0019C23.8492 25.1033 23.765 25.1874 23.6635 25.2459C23.5621 25.3044 23.447 25.3351 23.33 25.335H3.33462C3.2176 25.335 3.10263 25.3042 3.00129 25.2456C2.89995 25.1871 2.81579 25.103 2.75728 25.0016C2.69877 24.9003 2.66797 24.7853 2.66797 24.6683C2.66797 24.5513 2.69877 24.4363 2.75729 24.335L12.7553 7.0003C12.8138 6.89896 12.898 6.81481 12.9993 6.7563C13.1006 6.69779 13.2156 6.66699 13.3326 6.66699C13.4496 6.66699 13.5646 6.69779 13.6659 6.7563C13.7673 6.81481 13.8514 6.89896 13.91 7.0003L17.2566 12.8023C17.0089 13.4222 16.8676 14.0794 16.8386 14.7463L13.3326 8.6683Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.9873 19.2714C21.557 19.5123 22.1694 19.6359 22.788 19.6347C23.8554 19.6367 24.8903 19.2674 25.7153 18.59L28.33 21.204L29.3353 20.1987L26.666 17.5294C27.1821 16.7334 27.4409 15.798 27.4071 14.8499C27.3733 13.9019 27.0486 12.9872 26.4771 12.23C25.9056 11.4729 25.1149 10.9099 24.2125 10.6176C23.31 10.3252 22.3394 10.3176 21.4325 10.5958C20.5256 10.874 19.7262 11.4246 19.1429 12.1727C18.5597 12.9208 18.2207 13.8303 18.1721 14.7777C18.1235 15.7251 18.3676 16.6645 18.8712 17.4684C19.3748 18.2723 20.1136 18.9018 20.9873 19.2714ZM19.588 15.0127C19.588 15.8614 19.9251 16.6753 20.5252 17.2755C21.1254 17.8756 21.9393 18.2127 22.788 18.2127C23.6367 18.2127 24.4506 17.8756 25.0507 17.2755C25.6508 16.6753 25.988 15.8614 25.988 15.0127C25.988 14.164 25.6508 13.3501 25.0507 12.75C24.4506 12.1499 23.6367 11.8127 22.788 11.8127C21.9393 11.8127 21.1254 12.1499 20.5252 12.75C19.9251 13.3501 19.588 14.164 19.588 15.0127Z" fill="white"/>
<path d="M12.5 20.0333H14.1667V21.6999H12.5V20.0333ZM13.3333 13.3633C12.8733 13.3633 12.5 13.7366 12.5 14.1966V17.8633C12.5 18.0843 12.5878 18.2963 12.7441 18.4525C12.9004 18.6088 13.1123 18.6966 13.3333 18.6966C13.5543 18.6966 13.7663 18.6088 13.9226 18.4525C14.0789 18.2963 14.1667 18.0843 14.1667 17.8633V14.1966C14.1667 13.7366 13.7933 13.3633 13.3333 13.3633Z" fill="white"/>
</svg>

  ),
};

const financialPlanningData = {
  title: ["Financial Planning,", "Performance & Strategic Finance"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Enable forward-looking decision-making through structured financial planning, performance tracking, and capital strategy.",

  relevantFor: [
    "Corporates & Growth-Stage Businesses",
    "Family Offices",
    "Investment Banks & Advisors",
  ],

  heroImage:
    service1heroImage,

  services1: [
    {
      title: "Budgeting & Planning",
      description:
        "Develop integrated budgets aligned with strategic priorities to drive disciplined resource allocation.",
    },
    {
      title: "Forecasting & Scenario Modelling",
      description:
        "Build dynamic forecasts to support proactive decision-making under changing business conditions.",
    },
    {
      title: "Financial & Management Reporting",
      description:
        "Deliver timely, decision-grade reports that provide clear visibility into performance.",
    },
    {
      title: "Variance Analysis & Performance Insights",
      description:
        "Identify key drivers of performance gaps and enable targeted corrective actions.",
    },
    {
      title: "KPI Dashboards & Analytics",
      description:
        "Design real-time dashboards that translate financial data into actionable insights.",
    },
    
    
  ],

  services2: [
    {
      title: "Board & Stakeholder Reporting",
      description:
        "Prepare concise, insight-driven reporting for leadership, investors, and boards.",
    },
    {
      title: "Strategic Finance & Capital Advisory",
      description:
        "Support capital structuring, fundraising, and financial optimisation decisions.",
    },
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser1cs,
    title:"Annual Operating Plan and Budget",
    description:"A structured planning exercise provided strategic clarity by aligning annual departmental initiatives with long-term objectives, enabling the client to allocate resources effectively, track performance through KPIs, and drive data-informed decision-making across the organization.",   
    buttonLabel: "→",
    href: "/knowledge/annual-operating-plan-and-budget-for-a-single-family-office",
  },
};

const InvestmentFundData = {
  title: ["Investment", "& Fund Operations"],

  accentColor: "#f21b70",
  bg:'#EBEBEB',
  subtitle:
    "Deliver end-to-end financial operations across fund structures, ensuring accuracy, transparency, and investor confidence.",

  relevantFor: [
    "Private Equity & Venture Capital",
    "Hedge Funds & Asset Managers",
    "Sovereign Wealth Endowment Funds",
  ],

  heroImage:
    service2heroImage,

  services1: [
    {
      title: "Fund Accounting & NAV Management",
      description:
        "Perform NAV computation, shadow accounting, and valuation validation.",
    },
    {
      title: "Account Reconciliations & Validation",
      description:
        "Execute cash, bank, and position reconciliations to ensure data accuracy.",
    },
    {
      title: "Portfolio & Asset Monitoring",
      description:
        "Track portfolio holdings and corporate actions to support accurate reporting.",
    },
    {
      title: "Investor Reporting & Capital Statements",
      description:
        "Preparation of Investor Capital Statements & Investment Performance Reports.",
    },
    {
      title: "Capital Activity Management",
      description:
        "Manage capital calls and distributions in line with partnership agreements.",
    },
    
    
  ],

  services2: [
    {
      title: "Fee & Carry Computation",
      description:
        "Calculation of Management fees and other fund expenses.",
    },
    {
      title: "Waterfall Modelling & Performance Reporting",
      description:
        "Performance Fee & Carry Calculations as per LPA's, Calculating & Reporting Fund Performance Metrics (IRR, MOIC, DPI, TVPI).",
    },
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser2cs,
    title:"Periodic Portfolio Performance",
    description:"The performance assessment dashboard enabled the client to quickly assess the performance of the funds & portfolio companies, extract required information for the IC, and reduce time spent creating the document.",
    buttonLabel: "→",
    href: "/knowledge/periodic-portfolio-performance-review-for-a-u.s.based-pe-firm",
  },
};

const AccountingData = {
  title: ["Accounting, Controllership ", "& Financial Operations"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Ensure financial integrity through robust accounting processes, accurate reporting, and effective control frameworks.",

  relevantFor: [
    "Corporates & Growth-Stage Businesses",
    "Real Estate Platforms"
  ],

  heroImage:
    service3heroImage,

  services1: [
    {
      title: "Accounting & Close Management",
      description:
        "Manage end-to-end accounting, including month-end and year-end close processes.",
    },
    
    {
      title: "Financial Reporting",
      description:
        "Prepare statutory-compliant financial statements for regulatory and internal use.",
    },
    {
      title: "Reporting Compliance",
      description:
        "Assistance in correct application of accounting standards (US GAAP & IFRS) across complex transactions.",
    },
    {
      title: "Working Capital & Cash Management",
      description:
        "Optimise liquidity through structured management of receivables, payables, and cash flows.",
    },
    {
      title: "Operational Controls",
      description:
        "Implement operational controls to minimise risk and ensure financial accuracy.",
    },
    
    
  ],

  services2: [
    
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser3cs,
    title:"Finance & Accounting SOP Framework",
    description:"Established a standardized procedural framework across client assets, streamlining finance and accounting functions. Delivered 30+ SOPs, reducing operational, financial and regulatory risk while strengthening internal controls, governance and scalability across future properties.",
    buttonLabel: "→",
    href: "/knowledge/standard-operating-procedures-finance-&-accounting-sop-framework-for-an-ultra-luxury-hospitality-group",
  },
};

const GovernanceData = {
  title: ["Governance, Risk,", "Compliance & Transformation"],

  accentColor: "#f21b70",
  bg:'#EBEBEB',
  subtitle:
    "Strengthen financial governance, mitigate risk, and enable scalable finance operations.",

  relevantFor: [
    "Investment Banks & Advisors",
    "Sovereign Wealth & Endowment Funds",
    "Private Equity Venture Capital",
  ],

  heroImage:
    service4heroImage,

  services1: [
    {
      title: "Audit & Assurance Support",
      description:
        "Ensure audit readiness through structured documentation and coordination.",
    },
    {
      title: "Internal Controls Design & Assessment",
      description:
        "Build and evaluate control frameworks to safeguard financial operations.",
    },
    
    {
      title: "Covenant Monitoring",
      description:
        "Track compliance with financial covenants and contractual obligations.",
    },
    {
      title: "Regulatory Compliance & Filings",
      description:
        "Ensure organization readiness for the timely adherence to statutory and regulatory requirements.",
    },
    {
      title: "Enterprise Risk Management",
      description:
        "Identify and mitigate financial and operational risks.",
    },
    
    
  ],

  services2: [
    {
      title: "Process Documentation & SOPs",
      description:
        "Standardise workflows to improve consistency and audit readiness.",
    },
    {
      title: "Finance Transformation & Automation",
      description:
        "Modernise finance through automation, system integration, and digital tools.",
    },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser4cs,
    title:"Case Study Coming Soon",
    description:"",
    buttonLabel: "→",
    href: "#",
  },
};


 const faqData = {
    title: "What Leaders Want To Know",

    defaultOpen: 0,

    items: [
      {
        question:
          "What challenges do companies typically face when scaling their finance function?",

        answer:
          "At Preferred Square, we typically see companies reach out when they're facing one or more of the following: complexity around setting up or transitioning a fund, inconsistent NAV reporting or unresolved reconciliations, limited real-time visibility into cash and positions, delays in month-end reporting due to an under-resourced finance function, inefficiencies in capital calls, distributions or investor reporting, or pressure around audit readiness and regulatory compliance.",
      },

      {
        question:
          "What does the first week of an outsourced CFO or fund operations engagement look like?",

        answer:
          "At Preferred Square, engagements begin with a kick-off to align on objectives, followed by a review of financials, processes, and data. We then align with key stakeholders and set up the governance structure, before completing data access and systems onboarding - designed to give clients clarity and early momentum from day one.",
      },

      {
        question:
          "How should a finance or fund operations partner handle data security and confidentiality?",

        answer:

          "At Preferred Square, we take a structured approach: NDAs are in place before any data is shared, access controls and encrypted workflows protect sensitive information, and our processes are built to meet the due diligence expectations of regulated, data-sensitive environments. Preferred Square is an ISO 27001 and SOC 2 compliant firm, highlighting its robust safeguards for sensitive information - strict access controls, encryption, and secure workflows help meet the confidentiality and due diligence standards expected in regulated environments."

      },

      {
        question:
          "What's different about a specialist offshore finance partner versus a traditional outsourcing provider?",

        answer:
          "Companies that have worked with traditional offshore providers often cite a lack of domain expertise, communication inefficiencies, rigid template-based approaches, and passive execution without real insight. Preferred Square differentiates through specialist-led teams, a proactive and insight-driven approach, customised delivery frameworks, and strong governance and communication structures.",
      },

      {
        question:
          "What deliverables should companies expect from a fund operations or CFO advisory engagement?",

        answer:
          "Depending on the scope, companies can expect deliverables across financial planning, performance reporting, fund operations, accounting, and governance. These may include budgeting and forecasting models, management and board reporting, fund accounting and NAV support, investor reporting, cash and close management outputs, audit support, compliance documentation, and finance transformation recommendations.",
      },

       {

        question:
          "Should a growing company use a boutique advisory firm, a large consulting firm, a freelancer, or an in-house hire for fund accounting and CFO support?",

        answer:
          "Companies typically choose a boutique, specialist partner like Preferred Square for the combination of specialised domain expertise, a strong cost-to-value proposition, a scalable and flexible delivery model, and confidence in execution and track record - versus the higher cost of a large firm, the limited bandwidth of a freelancer, or the time and risk of building an in-house team from scratch.",
      },
    ],
  };


  const  caseStudies =  {
  "sectionTitle": "Case Studies",
  "items": [
    {
      "id": 1,
      "image": cofcs1,
      "title": "Annual performance reporting framework",
      "description": "A leading regional conglomerate with diversified interests across industrial & real estate, managing over USD 1Bn in assets, recognized for its commitment to operational excellence & sustainable growth",
      "link": "/knowledge/annual-performance-reporting-framework"
    },
    {
      "id": 2,
      "image": cofcs2,
      "title": "Finance and Accounting SOP Framework",
      "description": "A hospitality group, fully owned by a sovereign wealth fund, focused on transforming historic and cultural sites into ultra-luxury boutique hotels",
      "link": "/knowledge/standard-operating-procedures-finance-&-accounting-sop-framework-for-an-ultra-luxury-hospitality-group"
    },
    {
      "id": 3,
      "image": cofcs3,
      "title": "Quarterly Reporting Framework for US Private Equity",
      "description": "A US-based mid-market private equity platform with an investment thesis focused on growth equity opportunities across specialized market segments",
      "link": "/knowledge/quarterly-reporting-framework-for-a-us-private-equity"
    }
  ]
}

const CfoServices = ({setBlank}) => {
  return (
     <>
        <Helmet>
            <title>CFO Services</title>
             <meta property="og:title" content="CFO Services" />
             <meta name='og:description' content='CFO Services' />
             <meta name='keywords' content='' />
        </Helmet>
        <Menu setBlank={setBlank} />
        <ServicesHeader herocontent={herocontent} />
        <ServiceDesc serviceDes={serviceDes} />
        <AIInServices data={aiCFOData} icons={aiCFODataicons} setBlank={setBlank} />
        <ServiceSection data={financialPlanningData} />
        <ServiceSection data={InvestmentFundData} />
        <ServiceSection data={AccountingData} />
        <ServiceSection data={GovernanceData} />
        <Whoweserve />
        <Getintouch2 setBlank={setBlank} />
        <ServiceCS caseStudies={caseStudies} />
        <FaqServices data={faqData} />
        <FooterNew setBlank={setBlank} />
     </>
  )
}

export default CfoServices



